((Drupal, once) => {
  Drupal.behaviors.teideNavbar = {
    attach(context) {
      once('teide-navbar', '#main-navbar', context).forEach((navbar) => {
        navbar.addEventListener('show.bs.collapse', () => {
          document.body.classList.add('navbar-is-open');
        });
        navbar.addEventListener('hide.bs.collapse', () => {
          document.body.classList.remove('navbar-is-open');
        });
      });
    },
    detach(context, settings, trigger) {
      if (trigger === 'unload') {
        document.body.classList.remove('navbar-is-open');
      }
    },
  };
})(Drupal, once);
